import {Inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslationService } from "./translation.service";
import { HttpParams, HttpClient } from '@angular/common/http';
import { HelperService } from "./helper.service";
import {CITY} from "../tokens";


@Injectable({
  providedIn: 'root'
})
export class OffersService {
  city: string;
  constructor(
    private translationService: TranslationService,
    private helperService: HelperService,
    private http: HttpClient,
    @Inject(CITY) private injectedCity: string
  ) {
    this.city = this.injectedCity || this.helperService.getCity();
  }


  getOffers(routeParam): Observable<any> {
    const language = this.translationService.language;
    return this.http.get(`${environment.API_URL}lunchMenu/${this.city}/${language}/${routeParam}/`);
    //need nasko for this
  }

  getCurrentOffers(keyword: string): Observable<any> {
    const typeId = this.city != 'plovdiv' ? '1,3,5,119' : '9,10,87,107,113';
    const params = new HttpParams()
      .set("city", this.city)
      .set("action", "offersListing")
      .set("typeId", typeId)
      .set("keyword", keyword)
      .set("orderBy", "id");

    return this.http.get(environment.MOBIBLE_API_URL, { params: params });
  }

}
